import { FileText } from 'lucide-react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Champ } from './constantes';

export const InfosPV = ({ b, setB }) => {
  const set = (k) => (e) => setB((x) => ({ ...x, [k]: e.target.value }));
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-7 shadow-sm" data-testid="cp-infos-pv">
      <h3 className="flex items-center gap-2 text-base md:text-lg font-semibold text-[#0F172A]"><FileText className="h-5 w-5 text-[#6FA22E]" /> Informations du procès-verbal</h3>
      <p className="mt-1 text-sm text-slate-500">Imprimées sur le procès-verbal : secrétaire de séance, documents examinés et date du prochain conseil.</p>
      <div className="mt-5 grid gap-5 md:grid-cols-2">
        <Champ label="Secrétaire de séance">
          <Input value={b.secretaire_nom} onChange={set('secretaire_nom')} placeholder="Prénom Nom" data-testid="cp-secretaire" />
        </Champ>
        <Champ label="Date du prochain conseil">
          <Input type="date" value={b.prochain_conseil} onChange={set('prochain_conseil')} data-testid="cp-prochain-conseil" />
        </Champ>
        <Champ label="Documents examinés (un par ligne)" className="md:col-span-2">
          <Textarea rows={4} value={b.documents_examines} onChange={set('documents_examines')} data-testid="cp-documents-examines" />
        </Champ>
      </div>
    </section>
  );
};
